import API from '@/util/api/API'
import {
    GrantKeyResponse,
    GrantRequest,
    ShareLinkResponse,
    ShareLink,
    ShareLinkData
} from '@/types/api/share'
import { User } from '@/types/user'
import { ResponseWithData } from '@/types/api/api'

class ShareAPI {
    public async users(): Promise<User[]> {
        return API.get('store/peers')
    }

    public async peers(type: string, id: string): Promise<User[]> {
        return API.get(`store/${type}s/${id}/peers`)
    }

    public async subkeys(id: string): Promise<GrantKeyResponse> {
        return API.get(`store/vaults/${id}/subkeys`)
    }

    public async grant(type: string, id: string, data: GrantRequest): Promise<User[]> {
        return API.post(`store/${type}s/${id}/grant`, data)
    }

    public async revoke(type: string, id: string, userId: string): Promise<User[]> {
        return API.post(`store/${type}s/${id}/revoke`, { userId })
    }

    // Share external

    public async shareLink(
        entryId: string,
        maxViews: number
    ): Promise<ShareLinkResponse> {
        return API.post('share', { entryId, maxViews })
    }

    public async finalizeShareLink(
        linkId: string, documentKey: string
    ): Promise<ShareLinkResponse> {
        return API.put(`share/${linkId}`, { documentKey })
    }

    public async getShareLinks(entryId: string): Promise<ShareLink[]> {
        return API.get(`share/entry/${entryId}`)
    }

    public async disableLink(linkId: string): Promise<ShareLink> {
        return API.put(`share/${linkId}`, { active: false })
    }

    public async getSharedData(linkId: string): Promise<ShareLinkData> {
        return API.get(`share/${linkId}`)
    }
}

export default new ShareAPI()
